const departmentWiseReportRoute = {
    BASE_PATH: "/reports/department-wise-report",
}

export default departmentWiseReportRoute;